import { Facebook, Twitter, Linkedin, MessageCircle, Link2 } from 'lucide-react';
import { toast } from 'sonner';
import { useLanguage } from '../context/LanguageContext';

export const ShareButtons = ({ url, title }) => {
  const { language } = useLanguage();
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(title);

  const links = [
    {
      id: 'facebook',
      label: 'Facebook',
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: 'hover:bg-[#1877F2] hover:text-white',
    },
    {
      id: 'twitter',
      label: 'X (Twitter)',
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
      color: 'hover:bg-black hover:text-white',
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: 'hover:bg-[#0A66C2] hover:text-white',
    },
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      icon: MessageCircle,
      href: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      color: 'hover:bg-[#25D366] hover:text-white',
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(language === 'fr' ? 'Lien copié!' : 'Link copied!');
    } catch (e) {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        toast.success(language === 'fr' ? 'Lien copié!' : 'Link copied!');
      } catch (e2) {
        toast.error(language === 'fr' ? 'Impossible de copier le lien' : 'Could not copy link');
      }
      textarea.remove();
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      <span className="text-sm text-[#546A76] mr-1">
        {language === 'fr' ? 'Partager :' : 'Share:'}
      </span>
      {links.map((l) => (
        <a
          key={l.id}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${language === 'fr' ? 'Partager sur' : 'Share on'} ${l.label}`}
          data-testid={`share-${l.id}`}
          className={`w-9 h-9 rounded-full border border-[#E2E8F0] bg-white text-[#546A76] flex items-center justify-center transition-colors ${l.color}`}
        >
          <l.icon className="w-4 h-4" />
        </a>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label={language === 'fr' ? 'Copier le lien' : 'Copy link'}
        data-testid="share-copy-link"
        className="w-9 h-9 rounded-full border border-[#E2E8F0] bg-white text-[#546A76] flex items-center justify-center transition-colors hover:bg-[#D4AF37] hover:text-white"
      >
        <Link2 className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ShareButtons;
